import { defineComponent as _defineComponent } from 'vue'
import { useUserStore } from "@/store/user.store";
import { computed } from "vue";
import C4EIcon from "../commons/C4EIcon.vue";
import AmountView from "@/components/commons/AmountView.vue";
import i18n from "@/plugins/i18n";
import CoinAmount from "../commons/CoinAmount.vue";
import dataService from "@/services/data.service";
import {calculatePrice} from "@/utils/token-price";
import {useTokensStore} from "@/store/tokens.store";
import {useConfigurationStore} from "@/store/configuration.store";

const vestingStatus = true;


export default /*#__PURE__*/_defineComponent({
  __name: 'UserData',
  setup(__props, { expose: __expose }) {
  __expose();

function claimRewards(){
  dataService.onClaimRewards();
}

const total = computed(() => useUserStore().getTotal);
const locked = computed(()=> useUserStore().getVestingLockAmount);
const available = computed(() => useUserStore().getBalance);
const stacked = computed(()=> useUserStore().getTotalDelegated);
// const unstaked = computed(()=> useUserStore().getTotalUndelegating);
const unstaked = computed(()=> useUserStore().getSpendableBalance);
const price = computed( ()=>{
  return useTokensStore().getTokenPrice;
});

const representData = computed(()=> {
  const coins = [
    {
      header : i18n.global.t('USER_DATA.TOTAL'),
      amount: total.value || 0,
      showDenom: true,
      showPrice: true,
      allowCopyValue: true
    },
    {
      header : i18n.global.t('USER_DATA.AVAILABLE'),
      amount: available.value || 0,
      showDenom: false,
      showPrice: true,
      allowCopyValue: true
    },
    {
      header : i18n.global.t('USER_DATA.STAKED'),
      amount: stacked.value || 0,
      showDenom: false,
      showPrice: true,
      allowCopyValue: true
    },
    {
      header : i18n.global.t('USER_DATA.SPENDABLE'),
      amount: unstaked.value || 0,
      showDenom: false,
      showPrice: true,
      allowCopyValue: true
   },
  ];
  return coins;
});

const __returned__ = { claimRewards, total, locked, available, stacked, unstaked, vestingStatus, price, representData, get useUserStore() { return useUserStore }, C4EIcon, AmountView, CoinAmount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})